.embeddedContentFrame {
  width: 100%;
  position: relative;
  flex: 1;
  min-height: 0;
}

.contentIframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
}